import React from 'react';
import PropTypes from 'prop-types';
import { Button, message, Popconfirm } from 'antd';
import './btn.scss';

const ConfirmActionButton = ({
    title,
    description,
    onConfirm,
    onCancel,
    shape,
    placement,
    okText = "Yes",
    cancelText = "No",
    buttonText = "Confirm",
    buttonType = "danger"
}) => {
    const handleConfirm = async (e) => {
        if (onConfirm) {
            await onConfirm(e);
            // message.success('Action confirmed')
        }
    };

    const handleCancel = (e) => {
        if (onCancel) {
            onCancel(e);
        }
        // message.error('Action canceled');
    };

    return (
        <Popconfirm
            placement={placement}
            title={title}
            autoAdjustOverflow
            description={description}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            okText={okText}
            cancelText={cancelText}
        >
            <Button shape={shape} type={buttonType}>{buttonText}</Button>
        </Popconfirm>
    );
};

// Define prop types
ConfirmActionButton.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    okText: PropTypes.string,
    cancelText: PropTypes.string,
    buttonText: PropTypes.string,
    buttonType: PropTypes.string,
    shape: PropTypes.string,
    placement: PropTypes.string,
};

// Default props
ConfirmActionButton.defaultProps = {
    onConfirm: null,
    onCancel: null,
    okText: "Yes",
    cancelText: "No",
    shape: "circle",
    placement: "topRight",
    buttonText: "Confirm",
    buttonType: "danger",
};

export default ConfirmActionButton;